import { testimonials } from '@/mocks/testimonials';
import SectionHeader from './SectionHeader';

export default function Testimonials() {
  return (
    <section className="section-pad bg-background-50">
      <div className="container-page">
        <SectionHeader
          eyebrow="读者口碑"
          title="百万读者的快乐证明"
          desc="真实的追更感受，来自每一位一起「歪歪」的你。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item) => (
            <figure key={item.name} className="flex flex-col rounded-2xl border border-background-200/70 bg-background-100 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-200 text-xl">
                  {item.emoji}
                </span>
                <div>
                  <figcaption className="text-sm font-bold text-foreground-950">{item.name}</figcaption>
                  <p className="text-xs text-foreground-600">{item.role}</p>
                </div>
              </div>
              <div className="mt-3 flex gap-0.5 text-accent-600">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs" aria-hidden="true" />
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                “{item.content}”
              </blockquote>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}